import { c as _c } from "react/compiler-runtime";
import React from "react";
const FillEmailIcon = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <><svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none"><path d="M7.40496 8.76848C7.27273 8.85113 7.12397 8.88419 6.99174 8.88419C6.8595 8.88419 6.71074 8.85113 6.57851 8.76848L0 4.75195V10.0908C0 11.2313 0.92562 12.1569 2.06612 12.1569H11.9339C13.0744 12.1569 14 11.2313 14 10.0908V4.75195L7.40496 8.76848Z" fill="#4B4B4B" /><path d="M11.9342 1.84277H2.06641C1.0912 1.84277 0.264753 2.53699 0.0664062 3.46261L7.00855 7.69401L13.9342 3.46261C13.7358 2.53699 12.9094 1.84277 11.9342 1.84277Z" fill="#4B4B4B" /></svg></>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
export default FillEmailIcon;